import { forwardRef } from "react";
import { useTranslations } from "next-intl";

import {
  SHEET_BACK_CLASS,
  SHEET_BACK_ICON,
  type TSheetBackProps,
} from "@/ui/components/overlay/Sheet/Sheet.config";
import { cn } from "@/ui/lib";
import { Icon } from "../../primitives";

export const SheetBack = forwardRef<HTMLButtonElement, TSheetBackProps>(
  ({ "aria-label": ariaLabel, type = "button", className, ...props }, ref) => {
    const t = useTranslations("Libs.UI.Components.Sheet.SheetBack");

    return (
      <button
        aria-label={ariaLabel ?? t("back")}
        data-component="SheetBack"
        ref={ref}
        type={type}
        {...props}
        className={cn(SHEET_BACK_CLASS, className)}
      >
        <Icon icon={SHEET_BACK_ICON} />
      </button>
    );
  },
);

SheetBack.displayName = "SheetBack";
